const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    width: "153px",
    height: "114.8px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 153 114.8",
    style: {
      enableBackground: "new 0 0 153 114.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4285F4"
    },
    d: "M10.4,114.8h24.3V55.7L0,29.6v74.8C0,110.1,4.7,114.8,10.4,114.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34A853"
    },
    d: "M118.2,114.8h24.3c5.8,0,10.4-4.7,10.4-10.4V29.6l-34.8,26.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBBC04"
    },
    d: "M118.2,10.5v45.2L153,29.6V15.7c0-12.9-14.7-20.3-25-12.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA4335"
    },
    d: "M34.8,55.7V10.5l41.7,31.3l41.7-31.3v45.2L76.5,87"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5221F"
    },
    d: "M0,15.7v13.9l34.8,26.1V10.5L25,3.2C14.7-4.6,0,2.8,0,15.7"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGmail);
export default __webpack_public_path__ + "static/media/icon-gmail.844e8c1060f8c31318683bf86cf0b645.svg";
export { ForwardRef as ReactComponent };